import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Debate } from './debate';
import { environment } from 'environments/environment';
import { MarsHttpDataService } from 'app/mars/services/mars-http-data.service';

const DISPUTED = 'DISPUTED';
const CANCELLED = 'CANCELLED';
const CERTIFIED = 'CERTIFIED';
const ERASED = 'ERASED';

@Injectable()
export class MarsDebatesService extends MarsHttpDataService {
  public debateStatus = {
    disputed: DISPUTED,
    cancelled: CANCELLED,
    certified: CERTIFIED,
    erased: ERASED
  };

  private statusTranslationMap = {
    [DISPUTED]: 'questions.status.disputed',
    [CANCELLED]: 'questions.status.cancelled',
    [CERTIFIED]: 'questions.status.certified',
    [ERASED]: 'questions.status.erased'
  };

  constructor(protected injector: Injector) {
    super(injector, '/admin/debates');
  }

  getDebate(id: string): Observable<Debate> {
    return super.getItem(id);
  }

  getDebatesStats(options?: any) {
    const url = this.baseUrl + '/stats';
    return this.fetchRequest(url, options, null);
  }

  updateDebateQuestion(groupQuestionId, data: any) {
    const url = `${environment.MARS_API_URL}/questions/${groupQuestionId}/judge`;
    return super.putRequest(url, JSON.stringify(data), this.getRequestOptions());
  }

  getComputedDebateData(debate: Debate) {
    const debateId = debate.id;
    const groupQuestionStatus = debate.status;
    const groupQuestionStatusLabel = this.statusTranslationMap[groupQuestionStatus] || 'questions.status.default';

    const debateIsClosed = [CANCELLED, CERTIFIED, ERASED].includes(groupQuestionStatus);
    const debateIsErased = groupQuestionStatus === ERASED;
    const debateStatusLabel = debateIsClosed ? 'debates.status.closed' : 'debates.status.open';

    const positiveVotes = debate.votes ? debate.votes.positive || 0 : 0;
    const negativeVotes = debate.votes ? debate.votes.negative || 0 : 0;
    const totalVotes = positiveVotes + negativeVotes;
    const positiveVotePercentage = totalVotes > 0.0 ? Math.ceil((positiveVotes / totalVotes) * 100) : 0;
    const negativeVotePercentage = totalVotes > 0.0 ? Math.round((negativeVotes / totalVotes) * 100) : 0;
    const votesDiffPercentage = Math.abs(positiveVotePercentage - negativeVotePercentage);
    const isHotDebate = votesDiffPercentage >= 0 && votesDiffPercentage <= 5 ? true : false;

    const numOpinions = debate.debate ? debate.debate.length : 0;
    const numSessions = debate.session ? debate.session : 0;

    const computedDebateData = {
      debateId,
      groupQuestionId: debate.groupQuestionId,
      groupId: debate.groupId,
      groupQuestionStatus,
      groupQuestionStatusLabel,
      debateIsClosed,
      debateIsErased,
      debateStatusLabel,
      positiveVotePercentage,
      negativeVotePercentage,
      votesDiffPercentage,
      isHotDebate,
      numOpinions,
      numSessions,
      validStatuses: {
        CERTIFIED,
        CANCELLED,
        ERASED,
        DISPUTED
      }
    };

    return computedDebateData;
  }
}
